import { darken, lighten } from 'polished';
import styled from 'styled-components';

export const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;

export const Container = styled.div`
  width: 75%;
  max-width: 680px;
  height: 300px;
  display: flex;
  flex-direction: column;
  z-index: 10;

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    min-width: 90%;
    height: 300px;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 5px;
  border-top-left-radius: ${({ theme }) => theme.metrics.radius};
  border-top-right-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => theme.colors.primary};
  pointer-events: painted;
`;

export const Title = styled.h1`
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-bottom-left-radius: ${({ theme }) => theme.metrics.radius};
  border-bottom-right-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
`;

export const List = styled.ul`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Item = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
  color: ${({ theme }) => theme.colors.textBackground};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
  }

  &:nth-child(odd) {
    background-color: ${({ theme }) => darken(0.03, theme.colors.background)};

    &:hover {
      background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
    }
  }
`;
